export default __webpack_public_path__ + "static/media/icon-left-control-m.25f0a65c.svg";